<template>
  <v-container>
    <div>
      <div class="display-1">Aufgaben</div>
      <v-card>
        <v-list>
          <v-list-item v-for="(task, index) in tasks" :key="index" @click="toggleTask(index)">
            <v-list-item-action>
              <v-simple-checkbox color="info" :value="task.completed"/>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="task.text"/>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
    <v-row class="mt-4">
      <v-col cols="6">
        <v-card-actions>
          <v-btn @click="openDisplayWindow">Neues Fenster</v-btn>
          <v-spacer/>
          <v-btn @click="sendMessage({ action: 'reloadTasks' })" text>Fenster aktualisieren</v-btn>
          <v-spacer/>
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn small text v-on="on">Weitere</v-btn>
            </template>
            <v-btn @click="reset">
              Spiel komplett zurücksetzen
            </v-btn>
          </v-menu>
        </v-card-actions>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-subtitle>
            Timer
          </v-card-subtitle>
          <v-card-text>
            <v-text-field label="Dauer Minuten" v-model.number="timerValueMinutes"/>
            <v-btn text color="info" :disabled="!timerValueMinutes"  @click="sendMessage({ action: 'setTimer', minutes: timerValueMinutes })">
              Wert setzen
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="sendMessage({ action: 'startTimer' })">Timer starten</v-btn>
            <v-spacer/>
            <v-btn @click="sendMessage({ action: 'stopTimer' })">Timer anhalten</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import {EventPayload, EventType} from '@/types/EventTypes';
import {Task} from '@/types/TaskTypes';
import {TaskManager} from '@/TaskManager';

export default Vue.extend({
  components: {
  },
  data: () => ({
    tasks: [] as Task[],
    windows: [] as Window[],
    timerValueMinutes: 60,
  }),
  methods: {
    async reset() {
      TaskManager.clearTasks();
      this.tasks = await TaskManager.loadTasks();
      this.sendMessage({
        action: EventType.ReloadTasks,
      });
    },
    toggleTask(index: number) {
      const task = this.tasks[index];
      if (task) {
        task.completed = !task.completed;
        TaskManager.saveTasks(this.tasks);
        this.sendMessage({
          action: EventType.SetTask,
          task: {
            index,
            completed: task.completed,
          }
        })
      }
    },
    openDisplayWindow() {
      const win = window.open('/#/about');
      if (win) {
        this.windows.push(win);
      }
    },
    sendMessage(payload: EventPayload) {
      for (const window of this.windows) {
        window.postMessage({type: 'CONTROL', payload}, window.location.href);
      }
    },
  },
  async mounted() {
    this.tasks = await TaskManager.loadTasks();
  }
})
</script>
